import { usePremiumStudyPackDist } from "@hooks/usePremiumStudyPackDist";
import type { MixedItemTag } from "@memorang/types";

export const usePremiumStudyPackTags = (): MixedItemTag[] | undefined =>
	usePremiumStudyPackDist().data?.tags;
